module.exports = __webpack_public_path__ + "img/logo-dark.c40d25da.svg";